export default class Cookies {

	static set(key, value, time, path = '/', domain) {

		let expires = '';
		if (time) {
			const date = new Date();
			date.setTime(date.getTime() + (time * 24 * 60 * 60 * 1000));
			expires = '; expires=' + date.toGMTString();
		}

		document.cookie = key + '=' + value + expires + '; path=' + path + (domain ? '; domain=' + domain : '');
	}

	static remove(key) {
		this.create(key,'',-1);
	}

	static get(key) {
		const keyX = key + '=';
		const ca = document.cookie.split(';');
		for(let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1,c.length);
			}
			if (c.indexOf(keyX) === 0) {
				return c.substring(keyX.length,c.length);
			}
		}

		return null;
	}
}
